import { Notify } from 'quasar'
import { signOut, readAccessTokenFromStorage } from 'src/boot/auth'

export default (resource: RequestInfo, init?: RequestInit | undefined, token?: string | undefined) => (async (resource: RequestInfo, init: RequestInit, token?: string): Promise<Response> => {
  const accessToken = token || readAccessTokenFromStorage()
  if (accessToken) {
    init.headers = Object.assign(init.headers || {}, { Authorization: `Bearer ${accessToken}` })
  }
  const response: Response = await fetch(resource, init)
  if (response.status === 401) {
    signOut()
    return new Promise(unresolved)
  }
  if (response.status >= 500) {
    Notify.create({
      message: 'Connection Error!',
      position: 'center'
    })
    return new Promise(unresolved)
  }
  if (response.status >= 400) {
    return Promise.reject(response)
  }
  return Promise.resolve(response)
})(resource, init || {}, token)

function unresolved () { return undefined }
